/**
 * Created by laugh on 7/24/2018.
 */
// types.js
const SET_FILMS = 'SET_FILMS'

export default {
  SET_FILMS
}


// WEBPACK FOOTER //
// ./src/actions/types.js